export default "__VITE_ASSET__4i0QpDN___"